import ProfileDataStore from '../datastores/ProfileDataStore';
import ProfileDataStoreApiRest from '../datasources/axios/api/profile';

export default class ProfileDataStoreFactory {
  static create(): ProfileDataStore {
    return new ProfileDataStoreApiRest();
  }
}
